// import React, { useEffect, useState } from 'react';
// import { CircularProgress, Card, CardContent, Typography, Divider } from '@material-ui/core';
//
// interface ProfileData {
//     profileName: string;
//     distributorName: string;
//     credits: number;
//     pendingPayments: number;
// }
//
// const ProfileComponent: React.FC = () => {
//     const [loading, setLoading] = useState<boolean>(true);
//     const [profileData, setProfileData] = useState<ProfileData | null>(null);
//
//     useEffect(() => {
//         // Fetch data from the backend API
//         const fetchData = async () => {
//             try {
//                 const token = localStorage.getItem('token');
//                 if (!token) {
//
//                     return;
//                 }
//
//                 const response = await fetch('/api/v1/profile/homedata', {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 });
//
//                 if (response.ok) {
//                     const data = await response.json();
//                     setProfileData(data);
//                 } else {
//                     // Handle API error
//                 }
//             } catch (error) {
//                 // Handle fetch error
//             } finally {
//                 setLoading(false);
//             }
//         };
//
//         fetchData();
//     }, []);
//
//     return (
//         <>
//             {loading ? (
//                 <CircularProgress />
//             ) : (
//                 <div>
//                     {profileData && (
//                         <>
//                             <Typography variant="h6" style={{ fontFamily: 'Arial', fontWeight: 'bold' }}>Welcome {profileData.profileName}</Typography>
//                             <Typography variant="subtitle1" style={{ fontFamily: 'Arial' }}>Distributor: {profileData.distributorName}</Typography>
//                             <Divider />
//                             <div style={{ marginTop: '10px' }}>
//                                 <Card variant="outlined" style={{ backgroundColor: '#F9F9F9', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
//                                     <CardContent>
//                                         <Typography variant="h6" style={{ fontFamily: 'Arial', fontWeight: 'bold' }}>Credits</Typography>
//                                         <Typography variant="h4" style={{ fontFamily: 'Arial' }}>{profileData.credits}</Typography>
//                                     </CardContent>
//                                 </Card>
//                             </div>
//                             <div style={{ marginTop: '10px' }}>
//                                 <Card variant="outlined" style={{ backgroundColor: '#f50057', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
//                                     <CardContent>
//                                         <Typography variant="h6" style={{ fontFamily: 'Arial', fontWeight: 'bold', color: '#FFFFFF' }}>Pending Payments</Typography>
//                                         <Typography variant="h4" style={{ fontFamily: 'Arial', color: '#FFFFFF' }}>{profileData.pendingPayments}</Typography>
//                                     </CardContent>
//                                 </Card>
//                             </div>
//                         </>
//                     )}
//                 </div>
//             )}
//         </>
//     );
// };
//
// export default ProfileComponent;
import React, { useEffect, useState } from 'react';
import {EuiFieldPassword,EuiModalHeaderTitle,EuiButtonEmpty,EuiFieldText,EuiModalHeader,EuiSpacer,EuiPanel, EuiTitle, EuiFlexGroup, EuiFlexItem, EuiCard, EuiProgress, EuiButton, EuiText, EuiModal, EuiModalFooter, EuiModalBody } from '@elastic/eui';
import "./Topbar.css"

interface ProfileData {
    profileName: string;
    distributorName: string;
    credits: number;
    pendingPayments: number;
}

interface ProfileComponentProps {
    role: string;
}

const ProfileComponent: React.FC<ProfileComponentProps> = ({ role }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [profileData, setProfileData] = useState<ProfileData | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const [changePasswordResponse, setChangePasswordResponse] = useState<{ changedStatus: boolean; changedMessage: string } | null>(null);


    useEffect(() => {
        
        const fetchProfileData = async () => {
            try {
                
                const response = await fetch('api/v1/prof/homedata', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                const data: ProfileData = await response.json();
                setProfileData(data);
            } catch (error) {
                console.error('Error fetching profile data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);
    const handlePasswordChange = async () => {
        try {

            const response = await fetch('/api/v1/prof/changepass', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ oldPassword, newPassword }),
            });
            const data = await response.json();
            setChangePasswordResponse(data);

            alert(data.changedMesage);

            if (data.changedStatus) {
                localStorage.removeItem('token');
                window.location.href = '/login';
            } else {
                // Close the modal if the password change failed
                setIsModalVisible(false);
            }
        } catch (error) {
            console.error('Error changing password:', error);
        }
    };



    return (
        <div>
            {isLoading ? (
                <EuiProgress size="xs" color="accent" />
            ) : (
                <div>
                    <div className="top-bar-inside">
                        <div className="containeroftopbar">
                            <div className="logo-inside">Profile</div>
                        </div>
                    </div>
                    <EuiPanel paddingSize="l" className="profile-panel" style={{margin:"3%"}}>
                        <EuiTitle size="l">
                            <h1>Welcome, {profileData?.profileName}</h1>
                        </EuiTitle>
                        <div className="profile-info" style={{marginTop:"20px",padding:"15px" ,fontFamily: "Helvetica Neue, Arial, sans-serif",fontSize: "16px",fontWeight: "bold" }}>
                            <div >Role: {role}</div>
                            <br/>
                            <div>Distributor Name: {profileData?.distributorName}</div>
                        </div>
                        <div style={{marginTop:"20px"}}>
                        <EuiButton  onClick={() => setIsModalVisible(true)}>Change Password</EuiButton>
                        </div>
                    </EuiPanel>

                    <EuiFlexGroup gutterSize="l" className="profile-cards" style={{margin: "2%"}}>
                        <EuiFlexItem>
                            <EuiCard

                                paddingSize="xl"
                                title={profileData?.credits.toLocaleString()||""}
                                // style={{backgroundColor:"#f50057"}}
                                titleElement="h2"
                                betaBadgeProps={{
                                    label: 'Total credits',
                                    tooltipContent:
                                        'Total credit left in your account',
                                }}
                                onClick={() => {}}
                            />

                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiCard
                                paddingSize="xl"
                                title={profileData?.pendingPayments.toLocaleString()||""}
                                // style={{backgroundColor:"#f50057"}}
                                titleElement="h2"
                                betaBadgeProps={{
                                    label: 'Pending Payments',
                                    tooltipContent:
                                        'This amount should be payed to the distributor',
                                }}
                                onClick={() => {}}

                            />
                        </EuiFlexItem>
                    </EuiFlexGroup>

                    {isModalVisible && (
                        <EuiModal onClose={() => setIsModalVisible(false)}>
                            <EuiModalHeader>
                                <EuiModalHeaderTitle>Change Password</EuiModalHeaderTitle>
                            </EuiModalHeader>
                            <EuiModalBody>

                                    <EuiFieldPassword
                                        placeholder="Old password"
                                        type='dual'
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                        aria-label="Use aria labels when no actual label is in use"
                                    />

                                <EuiSpacer />
                                <EuiFieldPassword
                                    placeholder="New password"
                                    type='dual'
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    aria-label="Use aria labels when no actual label is in use"
                                />
                            </EuiModalBody>
                            <EuiModalFooter>
                                <EuiButtonEmpty onClick={() => setIsModalVisible(false)}>Cancel</EuiButtonEmpty>
                                <EuiButton onClick={handlePasswordChange} fill>
                                    Confirm
                                </EuiButton>
                            </EuiModalFooter>
                        </EuiModal>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProfileComponent;